import { render } from "./RollUserBets.vue?vue&type=template&id=2f395273&scoped=true"
import script from "./RollUserBets.vue?vue&type=script&lang=js"
export * from "./RollUserBets.vue?vue&type=script&lang=js"

import "./RollUserBets.vue?vue&type=style&index=0&id=2f395273&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f395273"]])

export default __exports__